<template>
  <b-overlay
      :show="loading"
      rounded="sm"
      class="user-status-report"
  >
    <b-card>
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-2">
        <b-card-title>فروش</b-card-title>
        <div class="d-flex">
          <div
              style="width:120px"
              class="mr-1"
          >
            <p class="font-small-2" style="margin: 0">از تاریخ</p>
            <date-picker
                v-model="fromDate"
                placeholder=""
            />
          </div>
          <div
              style="width:120px"
              class="mr-1"
          >
            <p class="font-small-2" style="margin: 0">تا تاریخ</p>
            <date-picker
                v-model="toDate"
                placeholder=""
                :min="fromDate"
            />
          </div>
          <div class="d-flex flex-column justify-content-end">
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="info"
                style="height:fit-content;padding-right:10px;padding-left:10px"
                @click="getData()"
            >
              <feather-icon icon="RefreshCcwIcon" />
            </b-button>
          </div>
        </div>
      </div>
      <b-card-body class="p-0">
        <b-row class="mb-1">
          <b-col class="col-12 col-md-4"></b-col>
          <b-col class="col-12 col-md-4" style="margin-bottom: 5px">
            <b-card bg-variant="light" class="mb-0">
              <div class="d-flex justify-content-between align-items-center">
                <div>
                  <h3>
                      <span v-if="data.Cost">
                        <span class="font-medium-5 font-weight-bolder" style="margin-left: 8px">{{ data.Cost | price }}</span>
                        <span class="font-small-3 text-muted">تومان</span>
                      </span>
                    <span v-else class="font-medium-5 font-weight-bolder">0</span>
                  </h3>
                  <span class="text-black-50">کل هزینه</span>
                </div>
                <b-avatar
                    size="40"
                    variant="light-warning"
                >
                  <feather-icon
                      size="20"
                      icon="DollarSignIcon"
                  />
                </b-avatar>
              </div>
            </b-card>
          </b-col>
          <b-col class="col-12 col-md-4" style="margin-bottom: 5px">
            <b-card bg-variant="light" class="mb-0">
              <div class="h-100 d-flex justify-content-between align-items-center">
                <div>
                  <h3>
                  <span v-if="data.Income">
                    <span class="font-medium-5 font-weight-bolder" style="margin-left: 8px">{{ data.Income | price }}</span>
                    <span class="font-small-3 text-muted">تومان</span>
                  </span>
                    <span v-else class="font-medium-5 font-weight-bolder">0</span>
                  </h3>
                  <span class="text-black-50">کل درامد</span>
                </div>
                <b-avatar
                    size="40"
                    variant="light-success"
                >
                  <feather-icon
                      size="20"
                      icon="TrendingUpIcon"
                  />
                </b-avatar>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-table
            :items="data.MetrixDetails"
            :fields="fields"
            responsive
            show-empty
        >
          <template #cell(Result)="data">
            {{ data.value | price }}
          </template>
          <template #empty="scope">
            <div class="text-muted text-center font-small-3">اطلاعاتی وجود ندارد</div>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </b-overlay>

</template>

<script>
export default {
  name: "saleReport",
  data() {
    return {
      loading: false,
      fromDate: '',
      toDate: '',
      data: {},
      fields: [
        {
          key: 'InstallStatus',
          label: 'عنوان',
        },
        {
          key: 'Count',
          label: 'تعداد',
        },
        {
          key: 'Result',
          label: 'حاصل',
        },
      ],
    }
  },
  methods: {
    getData() {
      if (!this.fromDate || !this.toDate) return
      let data = {
        FromDate: this.fromDate,
        ToDate: this.toDate,
      }

      this.loading = true

      this.$http.post(this.$api.attributions.report, data)
          .then(res => {
            this.data = res.data
          })
          .finally(() => {
            this.loading = false
          })
    }
  }
}
</script>